module.exports = __webpack_public_path__ + "img/swap_main.2fa08e9e.png";